import React, { Fragment } from 'react'
import SingleInputForm from '../SingleInputForm'
import MultiInputForm from '../MultiInputForm'

export default function AddTeamMembersForm({ inputMode }) {
  return (
    <Fragment>
      {inputMode === 'single' && <SingleInputForm />}
      {inputMode === 'multi' && <MultiInputForm />}
    </Fragment>
  )
}
